import { Logout } from 'components/atoms/buttons/Logout'
import { startTransition, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuthState } from 'recoil/atoms/auth.atom'
import { useRecoilValue } from 'recoil'

export const Header = (): JSX.Element => {
  const auth = useRecoilValue(AuthState)
  const isAdminUser = auth === 'ADMIN'
  const [isAdminMode, setIsAdminMode] = useState(() => {
    return localStorage.getItem('isAdminMode') === 'true'
  })

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!isAdminUser && isAdminMode) {
      setIsAdminMode(false)
    }
  }, [isAdminMode, isAdminUser])

  useEffect(() => {
    if (isAdminUser) {
      localStorage.setItem('isAdminMode', String(isAdminMode))
      return
    }
    localStorage.removeItem('isAdminMode')
  }, [isAdminMode, isAdminUser])

  const navItems = useMemo(() => {
    const items = [
      { label: 'ダッシュボード', path: '/dashboard' },
      { label: '注力顧客', path: '/focus-customers' },
      { label: '注力取引', path: '/projects-talents' },
      { label: '会社一覧', path: '/company' },
      { label: '会社登録', path: '/company/new' },
      { label: 'タスク管理', path: '/tasks' }
    ]

    if (isAdminUser) {
      if (isAdminMode) {
        items.push({ label: 'ユーザー管理', path: '/admin' })
        items.push({ label: '数値レポート', path: '/reports' })
        items.push({ label: '契約情報', path: '/contracts' })
        items.push({ label: '設定', path: '/settings' })
      }
    }

    return items
  }, [isAdminMode, isAdminUser])

  const isPathActive = (path: string): boolean => {
    if (path === '/company') {
      return (
        location.pathname === '/company' ||
        (location.pathname.startsWith('/company/') &&
          location.pathname !== '/company/new')
      )
    }
    return location.pathname === path
  }

  return (
    <header className={'sticky top-0 z-50 w-full bg-white'}>
      <div
        className={
          'flex items-center justify-between gap-4 border-b border-gray-200 px-6 py-3 shadow-sm'
        }
      >
        <button
          type={'button'}
          className={'flex shrink-0 items-center gap-2'}
          onClick={() => {
            startTransition(() => navigate('/dashboard'))
          }}
        >
          <img src={'/logo.png'} alt={'accum'} className={'h-10'} />
        </button>

        <nav className={'flex flex-1 flex-wrap items-center gap-2'}>
          {navItems.map((item) => {
            const isActive = isPathActive(item.path)
            return (
              <button
                key={item.path}
                type={'button'}
                className={`rounded px-4 py-2 text-sm transition-colors ${
                  isActive
                    ? 'bg-[#01695C] text-white'
                    : 'text-gray-600 hover:bg-[#f0f0f0]'
                }`}
                onClick={() => {
                  startTransition(() => navigate(item.path))
                }}
              >
                {item.label}
              </button>
            )
          })}
        </nav>

        <div className={'flex shrink-0 items-center gap-3'}>
          {isAdminUser && (
            <button
              type={'button'}
              className={`rounded border px-3 py-1 text-xs font-semibold transition-all ${
                isAdminMode
                  ? 'border-[#d0dcff] bg-[#f0f4ff] text-[#4a5899]'
                  : 'border-[#dddddd] bg-white text-gray-600 hover:bg-[#f8f9fa]'
              }`}
              onClick={() => {
                setIsAdminMode((prev) => !prev)
              }}
            >
              {isAdminMode ? '管理モード ON' : '管理モード OFF'}
            </button>
          )}
          <Logout />
        </div>
      </div>
    </header>
  )
}
